import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import VibhagCard from "./VibhagCard";
import useApi from "../../hooks/useApi";
import { isEmpty } from "../../generalFunctions";

const VibhagParent = () => {
  const [response, request] = useApi("/website/home/vibhag");
  const [vibhag, setVibhag] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    request();
  }, []); //eslint-disable-line

  useEffect(() => {
    if (!isEmpty(response.data) && !response.error && !response.isLoading) {
      setVibhag(response.data);
    }
  }, [response]);

  const handleVibhagClick = (vibhagData) => {
    // Navigate to detail page and pass the vibhag data
    navigate(`/vibhag/${vibhagData.id}`, {
      state: {
        vibhagName: vibhagData.name,
        documents: vibhagData.details,
      },
    });
  };

  return (
    <Row gutter={[8, 16]}>
      {vibhag.map((element) => (
        <Col xl={6} lg={6} md={12} sm={12} xs={12} key={element.id}>
          <VibhagCard
            vibhagName={element.name}
            imageSrc={element.image}
            onClick={() => handleVibhagClick(element)}
          />
        </Col>
      ))}
    </Row>
  );
};

export default VibhagParent;
